<template>
	<div class="sidebar-wrapper" :class="{ opened: opened }">
		<div class="head">
			<!-- <img v-if="loggedUser && loggedUser.account && loggedUser.account.logoDark" :src="loggedUser.account.logoDark.urlThumb" alt="" class="logo only-desktop" />
			<img v-else src="@/assets/logo.png" alt="" class="logo only-desktop" /> -->

			<div
				class="avatar"
				:style="{ backgroundImage: `url('${require('@/assets/img/no-avatar-image.gif')}')` }"
			></div>
			<div class="username">{{ loggedUser.name }} {{ loggedUser.lastname }}</div>
		</div>
		<!-- <div class="status">
			<div>
				<div class="label">Pendientes</div>
				<div class="value">15</div>
			</div>
		</div> -->

		<!-- <h3>Generales</h3> -->
		<div class="list-group list-group-flush mt-2 flex-grow-1">
			<!-- <router-link to="/" class="list-group-item list-group-item-action ">
				<i class="icon icon-model-s"></i>
				<span>Cargar vehículo</span>
			</router-link>

			<router-link to="/" class="list-group-item list-group-item-action ">
				<i class="icon icon-list-bullet"></i>
				<span>Tareas pendientes</span>
			</router-link>

			<router-link to="/payment/booking" class="list-group-item list-group-item-action ">
				<i class="icon icon-social-usd"></i>
				<span>Cobrar</span>
			</router-link> -->
		</div>

		<div class="list-group list-group-flush mt-2 ">
			<router-link to="/logout" class="list-group-item list-group-item-action ">
				<i class="icon icon-logout"></i>
				<span>Salir</span>
			</router-link>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
	name: "Sidebar",
	props: {
		opened: {
			default: false
		}
	},

	data() {
		return {
			showUserNotification: false,
			unreadCounter: 0,
			appVersion: process.env.VUE_APP_VERSION
		}
	},
	computed: {
		...mapGetters(["loggedUser"])
	}
}
</script>

<style scoped>
.sidebar-wrapper {
	width: 230px;
	height: 100%;
	overflow: hidden;
	top: 58px;
	z-index: 100;
	position: fixed;
	color: #ffffff;
	background-color: #505050;
	transition: all 0.3s ease-in-out;

	display: flex;
	flex-direction: column;

	height: calc(100% - 58px);
	left: -240px;
	-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
}

.sidebar-wrapper.opened {
	left: 0px !important;
}

.sidebar-wrapper .head {
	font-weight: normal;
	padding: 8px;
	display: flex;
	align-items: center;
	flex-direction: column;
	background-color: #00000030;
}
.sidebar-wrapper .head .avatar {
	width: 48px;
	height: 48px;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin: 8px auto;
}
.sidebar-wrapper .head .username {
	text-align: center;
	font-size: 1.1rem;
}

.status {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #00000030;
	padding: 8px;
}
.status > div {
	text-align: center;
	padding: 3px 10px;
}
.status .label {
	font-size: 0.6rem;
	opacity: 0.8;
}
.status .value {
	font-size: 1.2rem;
	line-height: 1.1rem;
}

.sidebar-wrapper .list-group {
	width: 100%;
	overflow: auto;
	max-height: calc(100% - 112px);
	display: block;
	background-color: inherit;
}
.sidebar-wrapper .list-group .list-group-item {
	background-color: transparent;
	color: inherit;
	padding: 0px;
	height: 44px;
	border: none;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.sidebar-wrapper .list-group .list-group-item:hover {
	background-color: #0e2542;
}
.sidebar-wrapper .list-group .list-group-item .icon {
	width: 54px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.sidebar-wrapper .list-group .list-group-item .icon i {
	color: inherit;
	font-size: 18px;
}
.sidebar-wrapper .list-group .list-group-item span {
	font-size: 13px;
	flex-grow: 1;
}
.sidebar-wrapper .list-group .list-group-item .expand {
	width: 54px;
	text-align: center;
	display: inline-block;
}
.sidebar-wrapper:hover .list-group .list-group-item span {
	opacity: 1;
}

.list-group-item.expandible:not(.collapsed) {
	background-color: #0e2542 !important;
}
.sidebar-wrapper .list-group .list-group-item-child {
	padding-left: 54px;
	height: 34px;
	line-height: 34px;
	background-color: #0e2542;
}
.sidebar-wrapper .list-group .list-group-item-child:hover {
	background-color: #0f2f56;
}
.sidebar-wrapper .list-group .list-group-item-child.selected {
	background-color: #114483;
}

.sidebar-wrapper h3 {
	font-size: 12px;
	text-transform: uppercase;
	padding: 20px 0px 0px 12px;
	margin: 0px;
	opacity: 0.5;
}

.list-group-item.collapsed .expand.when-open,
.list-group-item:not(.collapsed) .expand.when-closed {
	display: none;
}

.sidebar-wrapper .dropdown {
	width: 100%;
}
.sidebar-wrapper .btn.dropdown-toggle {
	height: 58px;
	background-color: #143155;
	color: #fff;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}

.sidebar-wrapper .dropdown .btn:hover {
	background-color: #133c6f;
}

.navbar .user-dropdown .btn.dropdown-toggle {
	/* height:58px; */
	background-color: #fff;
	color: #000;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}
.navbar .user-dropdown .btn.dropdown-toggle .avatar {
	width: 32px;
	height: 32px;
	border: 1px solid #d8d8d8;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin-right: 8px;
}
.navbar .user-dropdown .btn.dropdown-toggle .username {
	line-height: 14px;
	text-align: left;
	padding-right: 4px;
}

.icons-reminders {
	padding: 0px 16px;
	display: inline-flex;
	align-items: center;
}

.btn-header {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 32px;
	text-align: center;
	color: #78858a;
	border: 1px solid #d3d9db;
	border-radius: 100%;
	position: relative;
	margin: 0px 14px 0px 8px;
}
.btn-header .icon {
	font-size: 16px;
}
.btn-header .badge {
	border: solid 2px #fff;
	position: absolute;
	top: -6px;
	right: -10px;
	width: 20px;
	height: 20px;
	display: block;
	justify-content: center;
	align-items: center;
	padding: 0px;
	font-size: 10px;
	line-height: 17px;
	font-weight: 500;
}

.env-alert {
	display: flex;
	height: 22px;
	align-items: center;
	border-radius: 15px;
	padding: 4px 12px;
}
</style>
